const dangerRatPlayerSpritesheet = {
  "name": "dangerRatPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/dangerRatPlayerSpritesheet.png",
  "sprites": {
    "dangerRatPlayerHead": [0],
    "dangerRatPlayerBody": [1]
  }
}
export default dangerRatPlayerSpritesheet;
